import { SERVICE_HOST } from "../utils/auth/config";

export const STUDENT_INFO = `${SERVICE_HOST}/student-info/v1`;
export const STUDENT_INFO_STUDENT = `${STUDENT_INFO}/student`;
